/**
 * RESPONSIBILITY: the colours of the /adc page, for this page alone.
 *
 * Every field is optional and an empty one means "the site's own colour", so the page
 * starts out looking like the rest of the church and becomes festive only when somebody
 * picks a red or a green. Applied to the page's own element, never to :root — see
 * AdcPage — so a Christmas red cannot leak into the church's pages.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, Color } from '@framework/core/decorators';
import { SectionName } from '../section-names';

const EMPTY = 'Leave empty to use the site’s colour.';

@Section({ name: SectionName.AdcTheme, label: 'Austin Desi Christmas - Colours' })
export class AdcThemeSection {
  @Color({ label: 'Main colour', group: 'Brand colours', description: `Headings, header and footer. ${EMPTY}` })
  primary!: string;

  @Color({ label: 'Accent', group: 'Brand colours', description: `Buttons and rules. ${EMPTY}` })
  secondary!: string;

  @Color({ label: 'Frame', group: 'Brand colours', description: `The border round the opening title. ${EMPTY}` })
  olive!: string;

  @Color({ label: 'Page', group: 'Neutrals', description: `The page background. ${EMPTY}` })
  cream!: string;

  @Color({ label: 'Tint', group: 'Neutrals', description: `Every other band. ${EMPTY}` })
  mist!: string;

  @Color({ label: 'Sand', group: 'Neutrals', description: EMPTY })
  sand!: string;
}
